import { MAT_FILTER_KEYS } from '../../../types/mat-types';

const DISCOVERY_EXPORT_FILTER_KEYS = [
  'include_discovery_data_pool',
  'has_existing_mat',
  'data_verified',
  'vendor_exists',
  'extraction_batch',
  'include_experimental',
] as const;

type BuildMATExportParamsOptions = {
  dataPoolId?: string;
};

export function buildMATExportParams(
  search: string,
  { dataPoolId }: BuildMATExportParamsOptions = {}
) {
  const sp = new URLSearchParams(search);
  const params: Record<string, string> = {};

  const includeDiscovered = sp.get('includeDiscovered') === 'true';
  const includeReviewedOnly = sp.get('includeReviewedOnly') === 'true';
  const vendorExists = sp.get('vendorExists');

  (MAT_FILTER_KEYS as readonly string[]).forEach((k) => {
    const v = sp.get(k);
    if (v && v.trim() !== '') params[k] = v.trim();
  });

  DISCOVERY_EXPORT_FILTER_KEYS.forEach((k) => {
    const v = sp.get(k);
    if (v && v.trim() !== '') params[k] = v.trim();
  });

  if (!params.include_discovery_data_pool && includeDiscovered && dataPoolId) {
    params.include_discovery_data_pool = dataPoolId;
  }

  if (!params.include_discovery_data_pool) return params;

  // MAT page "Discovered" rows correspond to discoveries without an existing MAT row.
  if (!params.has_existing_mat) {
    params.has_existing_mat = 'false';
  }

  if (!params.data_verified && includeReviewedOnly) {
    params.data_verified = 'true';
  }

  if (!params.vendor_exists && (vendorExists === 'true' || vendorExists === 'false')) {
    params.vendor_exists = vendorExists;
  }

  return params;
}
